module.exports = __webpack_public_path__ + "img/4.db39666d.png";